import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SiteReadyPropsType } from '../../model';
import { messages, modalMessagesByProductKey } from '../messages';
import {
  ModalButton,
  ModalButtonContainer,
  ModalHeading,
  ModalReadySubHeading
} from '../styled';

export function SiteReadyView({
  productKey,
  goToProduct,
  takeMeBack
}: SiteReadyPropsType) {
  return (
    <div>
      <ModalHeading>
        <FormattedMessage
          {...messages.siteIsReadyModalHeader}
          values={{
            PRODUCT_NAME: (
              <FormattedMessage
                {...modalMessagesByProductKey[productKey].name}
              />
            )
          }}
        />
      </ModalHeading>
      <ModalReadySubHeading>
        <SanitizedFormattedHtmlMessage
          {...messages.siteIsReadyModalSubHeader}
        />
      </ModalReadySubHeading>
      <ModalButtonContainer justify="center" style={{ paddingTop: '48px' }}>
        <ModalButton
          data-testid={'take-me-back-btn'}
          appearance="link"
          onClick={takeMeBack}
        >
          <FormattedMessage {...messages.takeMeBack} />
        </ModalButton>
        <ModalButton
          data-testid={'go-to-product-btn'}
          appearance="primary"
          onClick={goToProduct}
        >
          <FormattedMessage
            {...messages.goToProduct}
            values={{
              PRODUCT_NAME: (
                <FormattedMessage
                  {...modalMessagesByProductKey[productKey].name}
                />
              )
            }}
          />
        </ModalButton>
      </ModalButtonContainer>
    </div>
  );
}
